'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = connect;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _eventEmitter = require('../Base/views/eventEmitter.c');

var _eventEmitter2 = _interopRequireDefault(_eventEmitter);

var _dataModel = require('../../common/backbone/dataModel');

var _dataModel2 = _interopRequireDefault(_dataModel);

var _dataCollection = require('../../common/backbone/dataCollection');

var _dataCollection2 = _interopRequireDefault(_dataCollection);

var _lodash = require('lodash.uniqueid');

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = require('lodash.throttle');

var _lodash4 = _interopRequireDefault(_lodash3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
* usage example
*
* connectStore({
*   nameOfModel: Model,
    nameOfCll: Collection,
    secondNameOfCll: Collection.getInstance(),
    nameOfModelWithAttr: {store: Model, attribute: 'attributeName'},
* })
* (Component)
*
* */

var ConnectStore = function (_EventEmitter) {
    _inherits(ConnectStore, _EventEmitter);

    function ConnectStore(props) {
        var _ret;

        _classCallCheck(this, ConnectStore);

        var _this = _possibleConstructorReturn(this, (ConnectStore.__proto__ || Object.getPrototypeOf(ConnectStore)).call(this, props));

        _this._bind = function () {
            if (_this.storageList && _typeof(_this.storageList) === 'object') {
                var storeName = void 0;

                for (storeName in _this.storageList) {
                    if (_this.storageList.hasOwnProperty(storeName)) {
                        var item = _this.storageList[storeName];

                        if (item instanceof _dataModel2.default || item instanceof _dataCollection2.default) {
                            _this._listen(item);
                            _this.propsStoreMap[storeName] = item;
                        } else if (item.storage) {
                            _this._listen(item.storage, item);
                            _this.propsStoreMap[storeName] = item.storage;
                        }
                    }
                }
            }

            return _this;
        };

        _this._listen = function (storage) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            if (storage instanceof _dataModel2.default) {
                if (typeof options.event === 'string') {
                    _this.listenTo(storage, options.event, _this._handleStoreChange);
                } else if (options.attribute) {
                    _this.listenTo(storage, 'change:' + options.attribute, _this._handleStoreChange);
                } else {
                    _this.listenTo(storage, 'change', _this._handleStoreChange);
                }
            } else if (storage instanceof _dataCollection2.default) {
                if (typeof options.event === 'string') {
                    _this.listenTo(storage, options.event, _this._handleStoreChange);
                } else {
                    _this.listenTo(storage, 'all', (0, _lodash4.default)(_this._handleStoreChange, 50, { leading: false }));
                }
            }
        };

        _this._handleStoreChange = function () {
            _this.iteration += 1;
            _this.setState({ __connectIterationId: _this.id + _this.iteration });
            return _this;
        };

        var proto = Object.getPrototypeOf(_this),
            ctr = proto.constructor;

        _this.ComponentToWrap = ctr.ComponentToWrap;
        _this.storageList = ctr.storageList;
        _this.id = (0, _lodash2.default)('connectStoreId');
        _this.iteration = 0;
        _this.propsStoreMap = {};

        _this._bind();

        return _ret = _this, _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ConnectStore, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.stopListening();
        }
    }, {
        key: 'render',
        value: function render() {
            if (typeof this.ComponentToWrap === 'function') {
                return _react2.default.createElement(this.ComponentToWrap, Object.assign({}, this.props, this.propsStoreMap));
            } else {
                return null;
            }
        }
    }]);

    return ConnectStore;
}(_eventEmitter2.default);

var connectFabric = function connectFabric(Component, storageList) {
    var _class, _temp;

    if (typeof Component !== 'function') {
        if (process && process.env.NODE_ENV !== 'production') {
            console.error('connectStore: cannot connect Constructor.');
        }

        return null;
    }

    return _temp = _class = function (_ConnectStore) {
        _inherits(_class, _ConnectStore);

        function _class() {
            _classCallCheck(this, _class);

            return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
        }

        return _class;
    }(ConnectStore), _class.ComponentToWrap = Component, _class.storageList = storageList, _class.displayName = 'ConnectStore(' + (Component.displayName || '') + ')', _temp;
};

function connect(storageList) {
    return function (Component) {
        return connectFabric(Component, storageList);
    };
}